import { useState, useEffect, useRef, FC } from 'react';
import styled from 'styled-components';
import { Truncate } from 'ui/utility/truncate';
import { Tooltip } from 'ui/tooltip';
import { colors, fontWeights } from 'ui/theme';
import { Link } from 'ui/links';

const LinkCell = styled(Link)`
  font-weight: ${fontWeights.regular};
  color: ${colors.textPrimary};
  text-decoration-color: transparent;
`;

type Props = {
  name: string | JSX.Element;
  id: number | string;
  textOnly?: boolean;
  maxWidth?: number;
};

export const TruncatedHeaderCell: FC<React.PropsWithChildren<Props>> = ({
  name,
  id,
  textOnly = false,
  maxWidth = 156,
}) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const ref = useRef(null);

  const campaignAnalyticsLink = `${window.location.origin}/analytics/campaignPerformance?campaignId=${id}`;

  useEffect(() => {
    // @ts-ignore
    if (ref.current.offsetWidth < ref.current.scrollWidth) {
      setIsTruncated(true);
    }
  }, []);
  if (textOnly) {
    if (isTruncated) {
      return (
        <Tooltip tooltipContent={name}>
          <Truncate ref={ref} maxWidth={maxWidth}>
            {name}
          </Truncate>
        </Tooltip>
      );
    }
    return (
      <Truncate ref={ref} maxWidth={maxWidth}>
        {name}
      </Truncate>
    );
  } else if (isTruncated) {
    return (
      <Tooltip tooltipContent={name}>
        <LinkCell href={campaignAnalyticsLink} target="_blank" rel="noopener noreferrer">
          <Truncate ref={ref} maxWidth={maxWidth}>
            {name}
          </Truncate>
        </LinkCell>
      </Tooltip>
    );
  }
  return (
    <LinkCell href={campaignAnalyticsLink} target="_blank" rel="noopener noreferrer">
      <Truncate ref={ref} maxWidth={maxWidth}>
        {name}
      </Truncate>
    </LinkCell>
  );
};
